export const WORK_DIR_NAME = 'project';
export const WORK_DIR = '';
export const MODIFICATIONS_TAG_NAME = 'versoriFileModifications';
export const VERSORI_FLOW_FILE_NAME = 'versori-flow.json';
export const INTEGRATION_FILE_NAME = 'integration.ts';
export const GOOGLE_ANALYTICS_ID = 'G-NK3VKENWVQ';
export const ARCHITECTURAL_DIAGRAM_FILE_NAME = 'architectural_diagram.md';
export const INTEGRATION_VARIABLES_FILE_NAME = 'integration-variables-schema.json';
export const DEPLOY_MESSAGE = 'Deploy my Integration';
export const FINAL_REPORT_MESSAGE = 'Generate a solution document from my research';
export const REGENERATE_FINAL_REPORT_MESSAGE = 'Re-generate the solution document from my research';
export const TRANSFORMATION_MAPPING_FILE_STEM = 'transformation_mapping_visualisation';
export const TRANSFORMATION_MAPPING_HTML_FILE_NAME = 'transformation_mapping_visualisation.html';
export const TRANSFORMATION_MAPPING_MD_FILE_NAME = 'transformation_mapping_visualisation.md';
export const GENERATE_WORKFLOWS_MESSAGE = 'Generate workflows based on the research findings and documents provided.';
export const REGENERATE_WORKFLOWS_MESSAGE =
  'Re-generate workflows based on the research findings and documents provided.';
export const DEPLOY_CHECKPOINT = 'deployCheckpoint';
export const SAVE_CHECKPOINT = 'saveCheckpoint';

// Workbench folders that research documents and workflows are stored under.
// Newly generated artifacts are grouped under a top-level `documents/` folder.
export const RESEARCH_DOCUMENTS_PREFIX = 'documents/research/';
export const RESEARCH_WORKFLOWS_PREFIX = 'documents/workflows/';

// Legacy folders these artifacts used to be stored under. Kept so files already
// persisted (or re-supplied by the backend) under the old paths are still
// recognised as documents/workflows after the rename.
export const LEGACY_RESEARCH_DOCUMENTS_PREFIX = 'research/documents/';
export const LEGACY_RESEARCH_WORKFLOWS_PREFIX = 'research/workflows/';

// Custom MIME type used when dragging an in-app file (e.g. from the build
// FileList) onto a drop target like the build chat. The value carried on the
// drag is the file's full path relative to the project root.
export const VERSORI_FILE_DRAG_TYPE = 'application/x-versori-file-path';
